import React from "react";
import { findAllUserPagedEvent } from "../../_events/users/find.event";
import { alertError } from "../../_utils/alerts";

export const useUserPaged = ({ page = 0, limit = 8 }) => {

    const [data, setData] = React.useState([]);

    const loadData = (p, l) => {
        findAllUserPagedEvent(p, l)
        .then(json => {
            setData(json.paged);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData(page, limit);
    }, [page, limit]);

    return { data, loadData };
}